export const otpSuccessDelayTime = 1000;



// WEBPACK FOOTER //
// ./src/constants/contants.js